import {Service} from '@s-ui/domain'

/**
 * @class
 * @implements Service
 */
export default class GetPendingPtaZeroValueService extends Service {
  constructor({pendingPtaVOFactory}) {
    super()

    this._pendingPtaVOFactory = pendingPtaVOFactory
  }

  /**
   * @return {Promise<Number>}
   */
  execute = () => Promise.resolve(this._pendingPtaVOFactory({pendingPta: 0}))
}
